<!--
  @Description: 
  @Author: wang.y 
  @Date: 2026-01-05 
-->
<template>
  <div>
    <div id="g_id_onload"
      data-client_id="266834115748-ikeposlrebote7paj408bj298sd1rram.apps.googleusercontent.com"
      data-context="signin_with"
      :data-ux_mode="uxMode"
      data-callback="googleSignCallback"
      data-auto_prompt="false"
      :data-login_uri="uxMode === 'redirect' ? `${$store.state.req_url3}/home/googleRedirect` : ''"
      :data-state="$route.fullPath">
    </div>
    <div class="g_id_signin"
      data-text="signin_with"
      data-size="medium"
      data-logo_alignment="center"
      data-locale="en"
      :data-width="width">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '320'
    },
    uxMode: {
      type: String,
      default: 'popup'
    },
  },
  components: {},
  created() {},
  mounted() {
    window.googleSignCallback = this.googleSignCallback
    // 2. 关键修复：DOM 渲染完成后，动态加载 GSI 脚本​
    this.$nextTick(() => {
      // 确保 Vue DOM 已完全渲染​
      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      document.body.appendChild(script)
    })
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    googleSignCallback(response) {
      this.$emit('success', response)
    },
  },
}
</script>